<main class="container">
    <h1 class="title text-center">Lista de Termos</h1>
    <div class="content" [innerHTML]="termos | termsFormater | higienizaHTML:'HTML'" #termosLista></div>
    <br><br>
</main>